module.exports = __webpack_public_path__ + "img/tickmark.fa2faedc.svg";